import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CONFIGCONSTANTS } from '../../../config/app-constants';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { OrderService } from '../../../_services/order.service';
import { Router } from '@angular/router';
import { CategoryService } from '../../../_services/category-service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../_services/loader.service';

@Component({
  selector: 'app-itemwisepurchase',
  templateUrl: './itemwisepurchase.component.html',
  styleUrls: ['./itemwisepurchase.component.scss']
})
export class ItemwisepurchaseComponent implements OnInit {
  uuid: any;
  moduleType: string;
  itemwisepurchaseData: any[] = [];
  // Get datatble configuration -- start
  loadingIndicator = false;
  reorderable = CONFIGCONSTANTS.datatableConfig.reorderable;
  scrollbarH = CONFIGCONSTANTS.datatableConfig.scrollbarH;
  serverSorting = CONFIGCONSTANTS.datatableConfig.serverSorting;
  serverPaging = false;
  piningRight = CONFIGCONSTANTS.datatableConfig.piningRight;
  headerHeight = CONFIGCONSTANTS.datatableConfig.headerHeight;
  footerHeight = CONFIGCONSTANTS.datatableConfig.footerHeight;
  rowHeight = CONFIGCONSTANTS.datatableConfig.rowHeight;
  limitList: any[] = CONFIGCONSTANTS.datatableConfig.limitList;
  ColumnMode = ColumnMode;
  totalReords = CONFIGCONSTANTS.datatableConfig.page.totalReords;
  pageNumber = CONFIGCONSTANTS.datatableConfig.page.pageNumber;
  size = CONFIGCONSTANTS.datatableConfig.page.size;
  dtMessages = CONFIGCONSTANTS.datatableConfig.dtMessages;
  @ViewChild(DatatableComponent, { static: false }) datatable: DatatableComponent;
  sortParam = '';
  sortOrder = '';
  // Get datatble configuration -- end
  momentDateTime24Format = CONFIGCONSTANTS.momentDateTime24Format || 'MM/DD/YYYY hh:mm:ss';
  momentDateFormat = CONFIGCONSTANTS.momentDateFormat || 'MM/DD/YYYY';
  readonly noColumnRecordText = CONFIGCONSTANTS["dataTableListing"]["columnRecordMissingText"];
  showNewRows = false;
  newRows: any[] = [];
  datePickerConfig = CONFIGCONSTANTS["datePickerConfig"];
  maxDate = new Date();
  minDate = new Date(CONFIGCONSTANTS["minYearSelectCalender"]);
  // qtyNotValid:boolean = false;
  batchNotValid:boolean = false;
  row: any;
  obj:any;
  rowAdded: boolean = false;
  qtyNotValid: boolean[] = [];
  batchNoNotValid: boolean[] = [];
  originalQty: any;
  originalDate: any;
  disableBatchField:boolean = false;

  constructor(
    private categoryService: CategoryService,
    public modalRef: BsModalRef,
    public modalRefDelete :BsModalRef,
    private modalService: BsModalService,
    private loader: LoaderService)
   { }

  ngOnInit() {
    this.getitemwise();
  }

 /**
   * Get status class from configuration
   * @param status Active/Inactive/Penging
   */
 public getStatusClass(status) {
  if (status) {
    return CONFIGCONSTANTS.statusClass[status];
  } else {
    return 'badge-primary';
  }
}
/**
 * Sort datatable fields
 * @param event event was triggered, start sort sequence
 */
public onSort(event) {
  this.sortParam = event.sorts[0].prop;
  this.sortOrder = event.sorts[0].dir;
  this.rerender(false);
}

/**
 * Populate the table with new data based on the page number
 * @param page The page to select
 */
public setPage(pageInfo) {
  this.pageNumber = pageInfo.offset;
  this.rerender(false);
}
/**
 * Show number of records in datatable
 * @param value show total entries value 10,25,50,100
 */
public changeLimit(value) {
  this.size = value;
  this.rerender(true);
  this.totalReords = this.itemwisepurchaseData.length;
}
/**
 * API call and refresh datatable value
 * @param goFirstPage set first page when param value true
 */
private rerender(goFirstPage): void {
  if (goFirstPage) {
    this.pageNumber = 0;
  }
  this.getitemwise();
}

getitemwise() {
  this.loadingIndicator = true;
  this.categoryService.getitemwise(this.uuid,{
    start: (this.pageNumber) * (this.size),
    length: this.size,
    // sort_param: this.sortParam,
    // sort_type: this.sortOrder
  })
    .pipe(first())
    .subscribe(res => {
      this.loadingIndicator = false;
      this.itemwisepurchaseData = res.data;
      this.totalReords = res.data;
    }, error => {
      this.loadingIndicator = false;
    });
}

decline(): void {
  this.modalRef.hide();
}




getCurrentDateTime() {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');

  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDateTime;
}

openDeleteModal(template: TemplateRef<any>, id?) {
  this.modalRefDelete = this.modalService.show(template, { class: 'modal-md' });
}

getColorCodeColor(colorCode: string): string {
  switch (colorCode) {
      case 'red':
          return '#ff0000';
      case 'yellow':
          return '#fe8900';
      case 'green':
          return '#16a34a';
      default:
          return '#5b12b7'; // Default color if no match
  }
}


}